import { render, staticRenderFns } from "./Calculations.vue?vue&type=template&id=74af2fcc&scoped=true"
import script from "./Calculations.vue?vue&type=script&lang=ts"
export * from "./Calculations.vue?vue&type=script&lang=ts"
import style0 from "./Calculations.vue?vue&type=style&index=0&id=74af2fcc&prod&scoped=true&lang=css"
import style1 from "./Calculations.vue?vue&type=style&index=1&id=74af2fcc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74af2fcc",
  null
  
)

export default component.exports